import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import {
  Container,
  Box,
  Typography,
  TextField,
  Button,
  Paper,
  Alert,
} from "@mui/material";
import PasswordField from "./PasswordField";
import apiClient from "./utils/apiClient";

const SignUp = () => {
  const [fullname, setFullname] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [message, setMessage] = useState("");
  const [isSubmitted, setIsSubmitted] = useState(false);
  const navigate = useNavigate();

  const handleSignUp = async (event) => {
    event.preventDefault();

    if (password !== confirmPassword) {
      setErrorMessage("Passwords do not match.");
      return;
    }

    try {
      await apiClient.post("/register", {
        id: email,
        email: email,
        fullname: fullname,
        password: password,
        client_base_url: window.location.origin,
      });
      setMessage("Check your email for a verification link. Click the link to verify your email address. If you don't see the email in your inbox, be sure to check your spam or junk folder.");
      setErrorMessage("");
      setIsSubmitted(true);
      setTimeout(() => {
        navigate("/login");
      }, 5000);
    } catch (error) {
      setErrorMessage(error.message || "Sign up failed. Please try again.");
      setMessage("");
    }
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        backgroundColor: "#b3e5fc",
        backgroundImage: "url(/freeze_data.png)",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <Container maxWidth="xs">
        <Paper
          elevation={10}
          sx={{
            padding: 4,
            borderRadius: 2,
            boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <Typography component="h1" variant="h5" sx={{ marginBottom: 2 }}>
              Continuous MFA Sign Up
            </Typography>

            {message && (
              <Alert severity="success" sx={{ mb: 2, width: "100%" }} data-testid="signup-success">
                {message}
              </Alert>
            )}
            {errorMessage && (
              <Alert severity="error" sx={{ mb: 2, width: "100%" }}>
                {errorMessage}
              </Alert>
            )}

            {!isSubmitted && (
              <Box
                component="form"
                onSubmit={handleSignUp}
                sx={{ mt: 1, width: "100%" }}
              >
                <TextField
                  margin="normal"
                  required
                  fullWidth
                  id="fullname"
                  label="Full Name"
                  name="fullname"
                  autoComplete="name"
                  autoFocus
                  value={fullname}
                  onChange={(e) => setFullname(e.target.value)}
                  inputProps={{
                    "data-testid": "signup-fullname",
                  }}
                />
                <TextField
                  margin="normal"
                  required
                  fullWidth
                  id="email"
                  label="Email Address"
                  name="email"
                  autoComplete="email"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  inputProps={{
                    "data-testid": "signup-email",
                  }}
                />
                <TextField
                  margin="normal"
                  required
                  fullWidth
                  name="password"
                  label="Password"
                  type="password"
                  id="password"
                  autoComplete="new-password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  inputProps={{
                    "data-testid": "signup-password",
                  }}
                />
                <TextField
                  margin="normal"
                  required
                  fullWidth
                  name="confirmPassword"
                  label="Confirm Password"
                  type="password"
                  id="confirmPassword"
                  autoComplete="new-password"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  inputProps={{
                    "data-testid": "signup-confirm-password",
                  }}
                />
                <Button
                  type="submit"
                  fullWidth
                  variant="contained"
                  sx={{ mt: 3, mb: 2 }}
                  data-testid="signup-submit"
                >
                  Sign Up
                </Button>
                <Box sx={{ textAlign: "center" }}>
                  <Link
                    to="/login"
                    style={{
                      textDecoration: "none",
                      color: "#2F3F5C",
                      fontSize: "14px",
                    }}
                  >
                    Already have an account? Log In
                  </Link>
                </Box>
              </Box>
            )}
          </Box>
        </Paper>
      </Container>
    </div>
  );
};

export default SignUp;
